export const healthCarrierOptions = [
  { value: "AETNA", description: "Aetna" },
  { value: "KAISER_PERMANENT", description: "Kaiser Permanente" },
  { value: "UNITED_HEALTHCARE", description: "UnitedHealthcare" },
  { value: "ANTHEM_HCSC", description: "Anthem BCBS" },
  { value: "OTHER", description: "Other" },
];
